import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { CLIENT_PROJECTS_INVITATIONS } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_projects_invitations = () => {
    return (dispatch, getState) => {

        return Auth.currentSession().then((session) => {

        const token = session && session.idToken.jwtToken;

        var config = { headers: { Authorization: 'Bearer ' + token } };

        return axios.get(`${Config.API_BASE_URL}/client/projects/invitations`, config)
            .then(response => {
                const payload = {
                    invitations: response.data,
                    errors: {},
                    task: {
                        result: true
                    }
                }
                dispatch({
                    type: CLIENT_PROJECTS_INVITATIONS,
                    payload: payload
                })
                return payload;

            })
            .catch(error => {
                const payload = {
                    errors: {},
                    task: {
                        result: false
                    }
                }
                dispatch({
                    type: CLIENT_PROJECTS_INVITATIONS,
                    payload: {
                        errors: {},
                        task: {
                            result: false
                        }
                    }
                })
                return payload;
            });
}).catch(error => {
 dispatch({ type: EXPIRED });
 });
 };
}

export default api_get_projects_invitations;
